import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type AuthHeaderProps = {
    useVanillaComponents?: boolean;
    messages?: Record<string, string>;
};

const AuthHeader = ({ useVanillaComponents, messages = {} }: AuthHeaderProps) => {
    const welcomeText = (messages['welcome.message'] || 'Welcome to the {brand} Portal').replace(
        '{brand}',
        'Victron Professional'
    );

    return (
        <>
            <img src="/static/img/logo.png" width={230} />
            <div>
                {useVanillaComponents ? (
                    <>
                        <p className="font-museo text-[40px] font-bold mt-10 -tracking-[2%] leading-[150%]">
                            Victron
                            <span className="text-primary-400 font-museo text-[40px] font-semibold -tracking-[2%]">
                                Professional
                            </span>
                        </p>
                        <p className="text-normal font-roboto tracking-[1%]">{welcomeText}</p>
                    </>
                ) : (
                    <>
                        <Typography
                            fontFamily="museo-sans"
                            fontSize={40}
                            fontWeight={600}
                            mt={5}
                            letterSpacing="-2%"
                            lineHeight="110%"
                        >
                            Victron
                            <Typography
                                component="span"
                                color="primary"
                                fontFamily="museo-sans"
                                fontSize={40}
                                fontWeight={600}
                                letterSpacing="-2%"
                            >
                                Professional
                            </Typography>
                        </Typography>
                        <Typography fontSize={16}>
                            <FormattedMessage
                                id="welcome.message"
                                defaultMessage="Welcome to the {brand} Portal"
                                values={{ brand: 'Victron Professional' }}
                            />
                        </Typography>
                    </>
                )}
            </div>
        </>
    );
};

export { AuthHeader };
